<input type="checkbox" [(ngModel)]="params.value" (change)="this.refresh(this.params)">